import { PrimeIcons } from "primereact/api";
import UserMenuConstants from "./UserMenuConstants";
export var getAdminMenuItems = function (navigate) {
    var userMenuitems = UserMenuConstants();
    var items = [
        {
            label: userMenuitems.admin.dashboard,
            icon: "pi pi-home",
            visible: true,
            command: function () { return navigate("/admin/dashboard"); },
        },
        {
            label: userMenuitems.admin.client.heading,
            icon: "pi pi-building-columns",
            visible: true,
            items: [
                {
                    label: userMenuitems.admin.client.mandantList,
                    icon: "pi pi-inbox",
                    visible: true,
                    command: function () { return navigate("/admin/client"); },
                },
                {
                    label: userMenuitems.admin.client.newmandant,
                    icon: "pi pi-file",
                    visible: true,
                    command: function () { return navigate("/admin/client/new"); },
                },
            ],
        },
        {
            label: userMenuitems.admin.messagestatistics,
            icon: "pi pi-chart-scatter",
            visible: true,
            command: function () { return navigate("/admin/message-statistics"); },
        },
        {
            label: userMenuitems.admin.declarationstatistics,
            icon: "pi pi-chart-scatter",
            visible: true,
            command: function () { return navigate("/admin/declaration-statistics"); },
        },
        {
            label: userMenuitems.admin.nonstampableitems.heading,
            icon: PrimeIcons.BAN,
            visible: true,
            items: [
                {
                    label: userMenuitems.admin.nonstampableitems.new,
                    icon: PrimeIcons.SHIELD,
                    visible: true,
                    command: function () { return navigate("/admin/nonstampableitems/new"); },
                },
            ],
        },
    ];
    return items;
};
